import {newLogger} from "../../../core/utils/logger";

const logger = newLogger('AboutUs');




// WEBPACK FOOTER //
// ./modules/landing/sections/about-us.js